import { useConditions } from 'mailup-react-helpers'
import {
  Card,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Icon,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  SKELETON_LOADER_TYPE_CIRCLE,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  SPACING_24,
  SPACING_40,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_ITALIC_LIGHT,
  TEXT_VARIANT_SMALL_LIGHT,
  Title,
  TITLE_VARIANT_L
} from 'mailup-web-components'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { initIntegrationsCallback } from '../../recoil/callbacks/callbacks'
import { integrationsState } from '../../recoil/state/page'

const SectionIntegration = () => {
  const intl = useIntl()
  const [isWhiteLabel] = useConditions(['co:WHITELABEL'])
  const [integrations, setIntegrations] = useRecoilState(integrationsState)

  const initIntegrations = useRecoilCallback(initIntegrationsCallback, [])
  useEffect(() => {
    if (!integrations.loaded) {
      initIntegrations()
    }
  }, [integrations.loaded])

  function goToIntegration(url) {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href: url,
      rel: 'noopener noreferrer'
    }).click()
  }
  const reloadSectionIntegrator = () => {
    setIntegrations((prev) => ({
      ...prev,
      loaded: false
    }))
  }

  return (
    <>
      {!isWhiteLabel && (
        <>
          <SpacingVertical variant={SPACING_40} />
          <Title variant={TITLE_VARIANT_L}>
            {intl.formatMessage({
              id: 'Load.DynamicContentList.lblDynamicContentIntegration'
            })}
          </Title>
          <Text>
            {intl.formatMessage({
              id: 'Load.DynamicContentList.lblDynamicContentIntegrationSubtitle'
            })}
          </Text>
          <SpacingVertical variant={SPACING_24} />

          {integrations.loading && (
            <Grid data-mu-test='flex-card-list'>
              {[0, 1, 2].map((item, key) => (
                <GridCell key={key} span={4}>
                  <Card data-mu-test='flex-card-listitem'>
                    <Flex
                      flexDirection='column'
                      justifyContent='center'
                      alignItems='center'
                    >
                      <SkeletonLoader
                        type={SKELETON_LOADER_TYPE_CIRCLE}
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                      />
                      <SpacingVertical variant={SPACING_24} />
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        width='60%'
                      />
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        width='100%'
                      />
                      <SkeletonLoader
                        variant={SKELETON_LOADER_VARIANT_ONWHITE}
                        width='100%'
                      />
                    </Flex>
                  </Card>
                </GridCell>
              ))}
            </Grid>
          )}
          {!integrations.loading && (
            <>
              {integrations.error ? (
                <Flex columnGap='4px'>
                  <Icon
                    family='fa'
                    icon='exclamation-triangle'
                    className='text-light'
                  />
                  <Text variant={TEXT_VARIANT_ITALIC_LIGHT} htmlElement='span'>
                    {intl.formatMessage(
                      { id: 'Load.DynamicContentList.ErrorInPage' },
                      {
                        link: (chunks) => (
                          <Link
                            variant={LINK_VARIANT_EXTRALIGHT}
                            onClick={reloadSectionIntegrator}
                          >
                            {chunks}
                          </Link>
                        )
                      }
                    )}
                  </Text>
                </Flex>
              ) : (
                <>
                  <Grid cols={12}>
                    {integrations.items.map((item, key) => (
                      <GridCell key={key} span={4}>
                        <Card
                          onClick={() => goToIntegration(item.url)}
                          data-mu-test='integrations-box'
                        >
                          <Flex
                            flexDirection='column'
                            rowGap='8px'
                            width='100%'
                            justifyContent='center'
                          >
                            <FlexItem margin='0 0 8px 0'>
                              <img width={71} height={71} src={item.logo} />
                            </FlexItem>

                            <Text variant={TEXT_VARIANT_BOLD}>
                              {item.title}
                            </Text>

                            <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                              {item.text}
                            </Text>
                          </Flex>
                        </Card>
                      </GridCell>
                    ))}
                  </Grid>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default SectionIntegration
